import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _a1b329c4 = function _a1b329c4() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _01e88be2 = function _01e88be2() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _0c2bbe60 = function _0c2bbe60() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _6d8a80e0 = function _6d8a80e0() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _308d94f6 = function _308d94f6() {
  return interopDefault(import('../pages/_market/_language/cart/index.vue'
  /* webpackChunkName: "pages/_market/_language/cart/index" */
  ));
};

var _ed44d734 = function _ed44d734() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _21bb953a = function _21bb953a() {
  return interopDefault(import('../pages/_market/_language/login/index.vue'
  /* webpackChunkName: "pages/_market/_language/login/index" */
  ));
};

var _38eb03f4 = function _38eb03f4() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _6d97fa3b = function _6d97fa3b() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _00b90c70 = function _00b90c70() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _a89bc758 = function _a89bc758() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _59f6a880 = function _59f6a880() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _08d0ac13 = function _08d0ac13() {
  return interopDefault(import('../pages/_market/_language/poc/grid.vue'
  /* webpackChunkName: "pages/_market/_language/poc/grid" */
  ));
};

var _618b2f5e = function _618b2f5e() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _52269cde = function _52269cde() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _3dff8f0a = function _3dff8f0a() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _f5795346 = function _f5795346() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _21de29d8 = function _21de29d8() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _626992fa = function _626992fa() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _9fc07f72 = function _9fc07f72() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _48f6b58a = function _48f6b58a() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _6f50df4c = function _6f50df4c() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _1f76028f = function _1f76028f() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _169d6028 = function _169d6028() {
  return interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
  ));
};

var _22587eda = function _22587eda() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _0832e3d2 = function _0832e3d2() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _1f6deff2 = function _1f6deff2() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _fc81abca = function _fc81abca() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _12a8e588 = function _12a8e588() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _e37f9710 = function _e37f9710() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _a38c61c0 = function _a38c61c0() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _17e6e058 = function _17e6e058() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _a35e3342 = function _a35e3342() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _eeddd25c = function _eeddd25c() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _2b0e62a6 = function _2b0e62a6() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _20ffd98e = function _20ffd98e() {
  return interopDefault(import('../pages/_market/_language/p/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/p/_slug" */
  ));
};

var _a89b032c = function _a89b032c() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _6f93e6d0 = function _6f93e6d0() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _a1b329c4,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _01e88be2,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _0c2bbe60,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _6d8a80e0,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _308d94f6,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _ed44d734,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _21bb953a,
      name: "market-language-login"
    }, {
      path: "/:market/:language/sitemap",
      component: _38eb03f4,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _6d97fa3b,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _00b90c70,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _a89bc758,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _59f6a880,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _08d0ac13,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _618b2f5e,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _52269cde,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _3dff8f0a,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _f5795346,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _21de29d8,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _626992fa,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _9fc07f72,
      children: [{
        path: "",
        component: _48f6b58a,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _6f50df4c,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _1f76028f,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _169d6028,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _22587eda,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _0832e3d2,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _1f6deff2,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _fc81abca,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _12a8e588,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _e37f9710,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _a38c61c0,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _17e6e058,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _a35e3342,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _eeddd25c,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _2b0e62a6,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:slug?",
      component: _20ffd98e,
      name: "market-language-p-slug"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _a89b032c,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _6f93e6d0,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}